import React from "react";
import { CaseSmall } from "../../assets/icons";
import { COLORS } from "../../constants/colors";
import { ASSETS } from "../../constants/requireAssets";
import Button from "../Button/button";
import GreyText from "../GreyText/greyText";
import IconComp from "../IconComp/iconComp";
import Text from "../Text/text";
import Title from "../Title/title";
import styles from "./productItem.module.css";
import { baseUrl } from "../../contants/API";
// import Zoom from 'react-medium-image-zoom'
// import 'react-medium-image-zoom/dist/styles.css'
import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";

interface Props {
  imgUrl?: string;
  heart?: any;
  name: string;
  price: number | string;
  discount?: number | string;
  count?: any;
  onHeartPress?: () => void;
  onBasketPress?: () => void;
  onBuyPress?: () => void;
}

const ProductItem = ({
  imgUrl,
  heart,
  name,
  price,
  discount,
  count,
  onHeartPress,
  onBasketPress,
  onBuyPress,
}: Props) => {
  return (
    <div className={styles.container}>
      <div className={styles.imgBox}>
        <PhotoProvider>
          <PhotoView src={`${baseUrl}/${imgUrl}`}>
            <img src={`${baseUrl}/${imgUrl}`} alt="" />
          </PhotoView>
        </PhotoProvider>
        <div className={styles.heartBox} onClick={onHeartPress}>
          {heart}
        </div>
      </div>
      <div className={styles.productInfo}>
      <div className={styles.nameBox}>
        <Text text={name} />
      </div>
      <div className={styles.priceBox}>
        <Title color={COLORS.orange} title={price} fontSize="14px" />
        <GreyText
          style={{ fontSize: "13px", textDecoration: "line-through" }}
          text={discount}
        />
      </div>
      <div className={styles.btnBox}>
        <Button
          btnSize="small"
          btnType="primary"
          title="В корзину"
          style={{ fontSize: "14px", height: "28px" }}
          onPress={onBuyPress}
        />
        <IconComp
          iconType="primary"
          style={{
            width: "28px",
            height: "28px",
            borderRadius: "8px",
            fontSize: "14px",
            color: COLORS.white,
          }}
          icon={count}
          onPress={onBasketPress}
        />
      </div>
      </div>
    </div>
  );
};

export default ProductItem;
